@for (item of nStats(); track $index) {
<div class="flex flex-col gap-2 justify-center items-center mb-2">
  <div class="w-[15%] h-4 rounded-5 animate-pulse bg-[#DDDEE0]"></div>
  <div class="flex w-full">
    <div class="flex flex-col flex-grow gap-1">
      <div class="w-[10%] h-3.5 rounded-5 animate-pulse bg-[#DDDEE0]"></div>
      <div
        class="w-full h-1.5 rounded-5 overflow-hidden animate-pulse bg-[#DDDEE0]"
      ></div>
    </div>
    <div class="flex flex-col flex-grow gap-1 items-end">
      <div class="w-[10%] h-3.5 rounded-5 animate-pulse bg-[#DDDEE0]"></div>
      <div
        class="w-full h-1.5 rounded-5 overflow-hidden animate-pulse bg-[#DDDEE0]"
      ></div>
    </div>
  </div>
</div>

}
